import React from 'react';
import { styled } from '@mui/system';

export interface ContainerBlockProps {
    children?: React.ReactNode;
}

const StyledGovContainerBlock = styled('div')(() => ({
    position: 'relative',
    marginBottom: '2.1875rem',
    padding: '1.875rem 3.125rem',
    backgroundColor: 'var(--gov-color-white)',
    borderRadius: '3px',
}));

export default function ContainerBlock(props: ContainerBlockProps) {
    const { children } = props;

    return (
        <StyledGovContainerBlock>
            {children}
        </StyledGovContainerBlock>
    );
}